/* Restore a saved normal-product variant through the SDK's existing radio controls.
 * No SDK replacement, catalog fetch, storage write or main-editor mutation.
 */
(() => {
  'use strict';
  const popupSelector='.tee-cross-sell-product-popup';
  const copy={de:'Bitte wähle Farbe und Größe erneut. Die vorherige Auswahl konnte nicht wiederhergestellt werden.',en:'Please select the colour and size again. Your previous selection could not be restored.',fr:'Veuillez choisir à nouveau la couleur et la taille. Votre sélection précédente n’a pas pu être rétablie.',es:'Selecciona de nuevo el color y la talla. No se ha podido recuperar tu selección anterior.',it:'Seleziona di nuovo colore e taglia. Non è stato possibile ripristinare la selezione precedente.'};
  const colorNames=[['Weiß','weiss','white','blanc','blanco','bianco'],['Schwarz','black','noir','negro','nero'],['Chocolate','chocolat','cioccolato'],['Navy','bleu marine','azul marino','blu navy'],['Army','army green','vert militaire','verde militar','verde militare'],['Hellblau','light blue','bleu clair','azul claro','azzurro'],['Pink','rose','rosa']];
  const key=s=>String(s).trim().toLowerCase();
  const color=s=>colorNames.findIndex(row=>row.some(v=>key(v)===key(s)));
  const id=s=>String(s||'').split('/').pop();
  function plan(groups,options){
    if(groups.length!==options.length)return null;
    return options.map((option,index)=>{
      const radios=Array.from(groups[index].querySelectorAll('input[type="radio"]'));
      const exact=radios.filter(r=>r.value===option.value);
      if(exact.length===1)return exact[0];
      // Equivalent color names only; sizes and unknown options must match exactly.
      const isColor=/farbe|color|colour|couleur|colore/i.test(option.name||'');
      const target=isColor?color(option.value):-1;
      const matches=target<0?[]:radios.filter(r=>color(r.value)===target);
      return matches.length===1?matches[0]:null;
    });
  }
  const frame=()=>new Promise(resolve=>requestAnimationFrame(resolve));
  let generation=0;
  document.addEventListener('click',event=>{
    const card=event.target.closest?.('.tee-cross-sell-product-button--has-product');
    if(!card || event.target.closest?.('.tee-cross-sell-product-preview__clear') || document.querySelector(popupSelector))return;
    const raw=window.teeinblue?.getCurrentCustomization?.()?.teeAddonProduct;
    if(!raw || raw.customizationData || !raw.product || !Array.isArray(raw.variantSelected?.selectedOptions) || !raw.variantSelected.selectedOptions.length)return;
    if(id(raw.selectedVariantId)!==id(raw.variantSelected.id))return;
    const saved=JSON.parse(JSON.stringify(raw)),ticket=++generation;
    const oldPopups=new Set(document.querySelectorAll(popupSelector));
    let observer,timer,found=false;
    function cancel(e){if(e.isTrusted&&e.target.closest?.(popupSelector)){generation++;stop();}}
    function stop(){observer?.disconnect();clearTimeout(timer);document.removeEventListener('pointerdown',cancel,true);document.removeEventListener('keydown',cancel,true);}
    async function attempt(){
      if(found||ticket!==generation)return;
      const popup=Array.from(document.querySelectorAll(popupSelector)).find(p=>!oldPopups.has(p));
      const form=popup?.querySelector('.tee-cross-sell-product__form');
      const groups=form&&Array.from(form.querySelectorAll('.tee-option'));
      if(!groups?.length || popup.querySelector('#tee-artwork-form'))return;
      found=true;stop();
      const choices=plan(groups,saved.variantSelected.selectedOptions);
      let needsChoice=false;
      const action=popup.querySelector('.tee-cross-sell-product__action');
      const locked=[form,action].filter(Boolean).map(el=>({el,inert:el.inert}));
      locked.forEach(({el})=>{el.inert=true});
      const changed=new Set();
      const guard=e=>{if(needsChoice&&e.target.closest?.('.tee-btn--atc')){e.preventDefault();e.stopImmediatePropagation();}};
      const userChoice=e=>{if(!e.isTrusted)return;const index=groups.findIndex(g=>g.contains(e.target));if(index>=0){changed.add(index);if(changed.size===groups.length){needsChoice=false;notice?.remove();}}};
      let notice;
      try{
        if(!choices||choices.some(x=>!x))throw Error('unmatched options');
        for(const input of choices){
          if(!popup.isConnected||!form.isConnected||ticket!==generation)return;
          if(input.disabled||input.closest('.tee-radio')?.classList.contains('tee-radio--unavailable'))throw Error('unavailable option');
          if(!input.checked){input.click();await frame();}
        }
        if(choices.some(input=>!input.checked))throw Error('selection not retained');
      }catch(_){
        needsChoice=true;
        const locale=(location.pathname.match(/^\/(de|en|fr|es|it)(?:-[a-z]{2})?(?=\/|$)/i)||[])[1]||'de';
        notice=document.createElement('p');notice.setAttribute('role','alert');notice.textContent=copy[locale]||copy.en;form.prepend(notice);
        popup.addEventListener('click',guard,true);popup.addEventListener('change',userChoice,true);
      }finally{locked.forEach(({el,inert})=>{el.inert=inert});}
    }
    document.addEventListener('pointerdown',cancel,true);document.addEventListener('keydown',cancel,true);
    observer=new MutationObserver(attempt);observer.observe(document.body,{childList:true,subtree:true});
    timer=setTimeout(stop,20000);queueMicrotask(attempt);
  },true);
})();
